import { Maybe, Nothing } from "purify-ts/Maybe"
import { PollData } from "@nvdb-rapport/shared/src/ApiData"

// MODEL

export interface ReportModel {
  contractId: Maybe<string>
  contract: Maybe<PollData>
  queriedAt: Date
}

export const initialReportModel: ReportModel = {
  contractId: Nothing,
  contract: Nothing,
  queriedAt: new Date(),
}

type SetReportId = { type: "SetReportId"; payload: Maybe<string> }
type SetReport = { type: "SetReport"; payload: Maybe<PollData> }
type SetQueriedAt = { type: "SetQueriedAt"; payload: Date }
type Reset = { type: "Reset" }

export type ReportAction = SetReportId | SetReport | SetQueriedAt | Reset

export function reportReducer(model: ReportModel, action: ReportAction) {
  switch (action.type) {
    case "SetReportId":
      return { ...model, contractId: action.payload }
    case "SetReport":
      return { ...model, contract: action.payload }
    case "SetQueriedAt":
      return { ...model, queriedAt: action.payload }
    case "Reset":
      return { ...model, initialContractModel: initialReportModel }
  }
}
